exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-auction p {\n  margin-bottom: 1rem;\n}\n.panel .panel-heading {\n  background: #ff7e23;\n  color: #fff;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  padding: 10px;\n}\n.panel .panel-body {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.panel .panel-body * {\n  line-height: 1;\n}\n.panel .panel-body .countdown-wrap {\n  background: #ff7e23;\n  padding: 10px;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #fff0ff;\n}\n.panel .panel-body .message-item {\n  line-height: 1;\n  margin-bottom: 10px;\n}", ""]);

// exports
